import type { LatLng } from '@lc/libgeo'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type PopupInfo = {
	type: string
	id: string
	pos: LatLng
}

export type TempSlice = {
	boardHeight?: number
	hoveredLine?: string | null
	popupOpened: PopupInfo | null
	popupHovered: PopupInfo | null
}
export const defaultTempSlice: TempSlice = {
	popupHovered: null,
	popupOpened: null,
}

export const tempSlice = createSlice({
	name: 'temp',
	initialState: defaultTempSlice,
	reducers: {
		setBoardHeight: (state, action: PayloadAction<number>) => {
			state.boardHeight = action.payload
		},
		setHoveredLine: (state, action: PayloadAction<string | null>) => {
			state.hoveredLine = action.payload
		},
		setPopupOpened: (state, action: PayloadAction<PopupInfo | null>) => {
			state.popupOpened = action.payload
		},
		setPopupHovered: (state, action: PayloadAction<PopupInfo | null>) => {
			state.popupHovered = action.payload
		},
	},
	selectors: {
		getBoardHeight: state => state.boardHeight,
		getHoveredLine: state => state.hoveredLine,
		getPopupOpened: state => state.popupOpened,
		getPopupHovered: state => state.popupHovered,
	},
})

export const {
	reducer: tempReducer,
	actions: {
		setBoardHeight,
		setHoveredLine,
		setPopupOpened,
		setPopupHovered,
	},
	selectors: {
		getBoardHeight,
		getHoveredLine,
		getPopupOpened,
		getPopupHovered,
	},
} = tempSlice
